<template>
    <div class="list--entry flex relative" @click="$router.push(`/overview/client/${client.id}`)">
        <div class="width--100 height--100 grid list--entry__grid1 font--s14">
            <div class="flex flex--column flex--center__hor pad--2 lineHeight--1">
                <div class="font--s1 color--grey">
                    Kunde
                </div>
                <div class="font--w700">
                    {{ client.name }}
                </div>
            </div>
            <div class="flex flex--center">
                <ActionButton icon="pencil" accent="true"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ActionButton from "@/components/Buttons/ActionButton";
    export default {
        components: {ActionButton},
        props: {
            client: {
                type: Object,
                default: () => {},
            }
        }
    }
</script>

<style scoped>

</style>
